import { PostingRulesPage } from '@/pages/shared/posting-rules';

export function TravelPostingRulesPage() {
  return <PostingRulesPage app="TRAVEL" />;
}
